import React from "react";
import ServicesBlock from "../components/ServicesBlock";

function services() {
  // Sewer Line Cleaning & Maintenance Icon
  const sewerCleaningIcon = (
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      {/* Sewer pipe */}
      <rect x="10" y="40" width="60" height="20" rx="10" fill="currentColor" stroke="currentColor" strokeWidth="2" />

      {/* Cleaning brush/spiral */}
      <circle cx="75" cy="50" r="8" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M 70 45 Q 75 40 80 45 Q 75 50 70 55 Q 75 60 80 55" fill="none" stroke="currentColor" strokeWidth="2" />

      {/* Cleaning equipment handle */}
      <line x1="83" y1="50" x2="95" y2="50" stroke="currentColor" strokeWidth="3" />

      {/* Water/cleaning flow */}
      <circle cx="25" cy="35" r="2" fill="currentColor" />
      <circle cx="35" cy="30" r="1.5" fill="currentColor" />
      <circle cx="45" cy="35" r="2" fill="currentColor" />
      <circle cx="55" cy="30" r="1.5" fill="currentColor" />

      {/* Pipe joints */}
      <line x1="30" y1="35" x2="30" y2="65" stroke="currentColor" strokeWidth="1" />
      <line x1="50" y1="35" x2="50" y2="65" stroke="currentColor" strokeWidth="1" />

      {/* Debris being removed */}
      <rect x="20" y="70" width="3" height="2" fill="currentColor" />
      <rect x="28" y="72" width="2" height="3" fill="currentColor" />
      <rect x="35" y="70" width="2" height="2" fill="currentColor" />
    </svg>
  );

  // Manhole Inspection and Management Icon
  const manholeInspectionIcon = (
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      {/* Manhole cover */}
      <circle cx="50" cy="30" r="20" fill="none" stroke="currentColor" strokeWidth="3" />

      {/* Manhole cover pattern */}
      <line x1="35" y1="25" x2="65" y2="25" stroke="currentColor" strokeWidth="1" />
      <line x1="35" y1="30" x2="65" y2="30" stroke="currentColor" strokeWidth="1" />
      <line x1="35" y1="35" x2="65" y2="35" stroke="currentColor" strokeWidth="1" />
      <line x1="45" y1="15" x2="45" y2="45" stroke="currentColor" strokeWidth="1" />
      <line x1="55" y1="15" x2="55" y2="45" stroke="currentColor" strokeWidth="1" />

      {/* Underground chamber */}
      <rect x="35" y="50" width="30" height="35" fill="none" stroke="currentColor" strokeWidth="2" />

      {/* Connecting pipes */}
      <rect x="15" y="65" width="20" height="8" fill="none" stroke="currentColor" strokeWidth="2" />
      <rect x="65" y="65" width="20" height="8" fill="none" stroke="currentColor" strokeWidth="2" />

      {/* Inspection equipment */}
      <circle cx="75" cy="20" r="5" fill="none" stroke="currentColor" strokeWidth="2" />
      <line x1="75" y1="15" x2="75" y2="10" stroke="currentColor" strokeWidth="2" />
      <line x1="75" y1="25" x2="75" y2="30" stroke="currentColor" strokeWidth="2" />
      <line x1="80" y1="20" x2="85" y2="20" stroke="currentColor" strokeWidth="2" />

      {/* Inspection light beam */}
      <path d="M 70 20 L 55 35 L 60 40 L 75 25 Z" fill="currentColor" opacity="0.3" />

      {/* Water level indicator */}
      <rect x="37" y="75" width="26" height="5" fill="currentColor" opacity="0.5" />
    </svg>
  );

  // Desilting Operations & Drainage Upkeep Icon
  const desiltingIcon = (
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      {/* Drainage channel */}
      <path d="M 10 60 L 90 60 L 85 80 L 15 80 Z" fill="none" stroke="currentColor" strokeWidth="2" />

      {/* Silt/sediment layers */}
      <path d="M 15 75 Q 25 70 35 75 Q 45 72 55 75 Q 65 70 75 75 Q 80 73 85 75 L 85 80 L 15 80 Z" fill="currentColor" opacity="0.6" />

      {/* Excavation equipment */}
      <rect x="40" y="20" width="20" height="8" fill="none" stroke="currentColor" strokeWidth="2" />
      <line x1="35" y1="28" x2="35" y2="45" stroke="currentColor" strokeWidth="3" />
      <line x1="65" y1="28" x2="65" y2="45" stroke="currentColor" strokeWidth="3" />

      {/* Excavator bucket */}
      <path d="M 30 45 L 40 50 L 40 55 L 25 55 Z" fill="currentColor" />

      {/* Suction hose */}
      <path d="M 70 28 Q 75 35 80 45 Q 85 55 90 65" fill="none" stroke="currentColor" strokeWidth="3" />

      {/* Removed silt particles */}
      <circle cx="25" cy="35" r="1" fill="currentColor" />
      <circle cx="30" cy="32" r="1.5" fill="currentColor" />
      <circle cx="35" cy="38" r="1" fill="currentColor" />
      <circle cx="28" cy="40" r="1" fill="currentColor" />

      {/* Water flow arrows */}
      <path d="M 15 50 L 25 50 M 20 45 L 25 50 L 20 55" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M 75 50 L 85 50 M 80 45 L 85 50 L 80 55" fill="none" stroke="currentColor" strokeWidth="2" />

      {/* Drainage grate */}
      <rect x="45" y="10" width="10" height="10" fill="none" stroke="currentColor" strokeWidth="1" />
      <line x1="47" y1="12" x2="47" y2="18" stroke="currentColor" strokeWidth="1" />
      <line x1="50" y1="12" x2="50" y2="18" stroke="currentColor" strokeWidth="1" />
      <line x1="53" y1="12" x2="53" y2="18" stroke="currentColor" strokeWidth="1" />
    </svg>
  );

  // Super Sucker Machines & Suction Tanks Icon
  const superSuckerIcon = (
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      {/* Truck chassis */}
      <rect x="15" y="55" width="60" height="20" rx="3" fill="none" stroke="currentColor" strokeWidth="2" />

      {/* Suction tank */}
      <ellipse cx="45" cy="40" rx="25" ry="12" fill="none" stroke="currentColor" strokeWidth="3" />
      <line x1="20" y1="40" x2="70" y2="40" stroke="currentColor" strokeWidth="2" />

      {/* Tank details */}
      <line x1="30" y1="32" x2="30" y2="48" stroke="currentColor" strokeWidth="1" />
      <line x1="45" y1="32" x2="45" y2="48" stroke="currentColor" strokeWidth="1" />
      <line x1="60" y1="32" x2="60" y2="48" stroke="currentColor" strokeWidth="1" />

      {/* Suction hose */}
      <path d="M 75 55 Q 85 45 90 35 Q 85 25 80 20" fill="none" stroke="currentColor" strokeWidth="4" />

      {/* Hose nozzle */}
      <circle cx="80" cy="20" r="3" fill="currentColor" />

      {/* Suction lines/particles */}
      <path d="M 78 25 L 72 35 M 82 28 L 76 38 M 85 30 L 79 40" stroke="currentColor" strokeWidth="1.5" />

      {/* Wheels */}
      <circle cx="25" cy="80" r="6" fill="none" stroke="currentColor" strokeWidth="2" />
      <circle cx="65" cy="80" r="6" fill="none" stroke="currentColor" strokeWidth="2" />

      {/* Vacuum pump */}
      <rect x="50" y="20" width="15" height="8" rx="2" fill="none" stroke="currentColor" strokeWidth="2" />
      <circle cx="57.5" cy="24" r="2" fill="currentColor" />

      {/* Pressure gauge */}
      <circle cx="35" cy="25" r="4" fill="none" stroke="currentColor" strokeWidth="2" />
      <line x1="35" y1="25" x2="37" y2="22" stroke="currentColor" strokeWidth="1" />

      {/* Control panel */}
      <rect x="55" y="50" width="8" height="5" fill="none" stroke="currentColor" strokeWidth="1" />
      <circle cx="57" cy="52.5" r="1" fill="currentColor" />
      <circle cx="61" cy="52.5" r="1" fill="currentColor" />
    </svg>
  );

  // Rental Solutions for Municipal Operations Icon
  const rentalSolutionsIcon = (
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      {/* Calendar/Schedule */}
      <rect x="15" y="15" width="25" height="20" fill="none" stroke="currentColor" strokeWidth="2" />
      <line x1="20" y1="20" x2="35" y2="20" stroke="currentColor" strokeWidth="1" />
      <line x1="20" y1="25" x2="35" y2="25" stroke="currentColor" strokeWidth="1" />
      <line x1="20" y1="30" x2="35" y2="30" stroke="currentColor" strokeWidth="1" />
      <rect x="22" y="27" width="3" height="3" fill="currentColor" />

      {/* Equipment fleet */}
      <rect x="50" y="20" width="15" height="8" rx="2" fill="none" stroke="currentColor" strokeWidth="2" />
      <circle cx="52" cy="32" r="3" fill="none" stroke="currentColor" strokeWidth="2" />
      <circle cx="63" cy="32" r="3" fill="none" stroke="currentColor" strokeWidth="2" />

      <rect x="70" y="15" width="12" height="6" rx="2" fill="none" stroke="currentColor" strokeWidth="2" />
      <circle cx="72" cy="25" r="2" fill="none" stroke="currentColor" strokeWidth="2" />
      <circle cx="80" cy="25" r="2" fill="none" stroke="currentColor" strokeWidth="2" />

      {/* Key/Access symbol */}
      <circle cx="25" cy="50" r="5" fill="none" stroke="currentColor" strokeWidth="2" />
      <rect x="30" y="48" width="8" height="4" fill="none" stroke="currentColor" strokeWidth="2" />
      <line x1="32" y1="46" x2="32" y2="54" stroke="currentColor" strokeWidth="1" />
      <line x1="35" y1="46" x2="35" y2="54" stroke="currentColor" strokeWidth="1" />

      {/* Contract/Document */}
      <rect x="50" y="45" width="20" height="25" fill="none" stroke="currentColor" strokeWidth="2" />
      <line x1="53" y1="50" x2="67" y2="50" stroke="currentColor" strokeWidth="1" />
      <line x1="53" y1="55" x2="67" y2="55" stroke="currentColor" strokeWidth="1" />
      <line x1="53" y1="60" x2="67" y2="60" stroke="currentColor" strokeWidth="1" />
      <line x1="53" y1="65" x2="60" y2="65" stroke="currentColor" strokeWidth="1" />

      {/* Signature line */}
      <path d="M 53 67 Q 58 65 63 67" fill="none" stroke="currentColor" strokeWidth="1" />

      {/* Service arrows/flow */}
      <path d="M 40 27 L 48 27 M 45 23 L 48 27 L 45 31" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M 40 52 L 48 52 M 45 48 L 48 52 L 45 56" fill="none" stroke="currentColor" strokeWidth="2" />

      {/* Municipal building symbol */}
      <rect x="15" y="75" width="25" height="15" fill="none" stroke="currentColor" strokeWidth="2" />
      <polygon points="15,75 27.5,65 40,75" fill="none" stroke="currentColor" strokeWidth="2" />
      <rect x="22" y="80" width="3" height="5" fill="currentColor" />
      <rect x="30" y="80" width="3" height="5" fill="currentColor" />

      {/* Time/Clock element */}
      <circle cx="75" cy="75" r="8" fill="none" stroke="currentColor" strokeWidth="2" />
      <line x1="75" y1="75" x2="75" y2="70" stroke="currentColor" strokeWidth="2" />
      <line x1="75" y1="75" x2="78" y2="78" stroke="currentColor" strokeWidth="1" />
    </svg>
  );

  return (
    <div id="services" className="services-container">
      <div className="services-header">
        <h1>OUR SERVICES</h1>
        <div className="divider"></div>
      </div>
      <div className="services-block-container">
        <ServicesBlock
          title="SEWER LINE CLEANING & MAINTENANCE"
          description="Seatech Infra offers end-to-end solutions for sewer line cleaning and upkeep, ensuring urban environments remain hygienic. Its expert teams and advanced technologies are deployed to manage complex sanitation requirements with efficiency and precision."
          svg={sewerCleaningIcon}
        />
        <ServicesBlock
          title="MANHOLE INSPECTION AND MANAGEMENT"
          description="The company conducts thorough inspections and management of manholes. Regular assessment and maintenance help prevent blockages, improve safety, and reduce the risk of urban flooding."
          svg={manholeInspectionIcon}
        />
        <ServicesBlock
          title="DESILTING OPERATIONS & DRAINAGE UPKEEP"
          description="Seatech Infra is adept at desilting operations, essential for maintaining free-flowing drainage systems. Its services also extend to the lining, repair, and overall upkeep of drainage networks to support municipal resilience."
          svg={desiltingIcon}
        />
        <ServicesBlock
          title="SUPER SUCKER MACHINES & SUCTION TANKS"
          description="By utilizing state-of-the-art Super Sucker Machines and high-capacity suction tanks, Seatech Infra delivers robust cleaning operations that are both effective and environmentally friendly. These machines support large-scale sanitation efforts in metropolitan settings."
          svg={superSuckerIcon}
        />
        <ServicesBlock
          title="RENTAL SOLUTIONS FOR MUNICIPAL OPERATIONS"
          description="The company provides rental vehicles and equipment, allowing municipalities and service agencies the flexibility to address sanitation challenges promptly and efficiently, without long-term capital investment."
          svg={rentalSolutionsIcon}
        />
      </div>
    </div>
  );
}

export default services;